// import * as React from "react";
import { atom } from "recoil";
import { IOptionData, useXoraiaValue } from "./useXoraia";
import useSWR from "swr";

export const USE_OPTIONS = atom<IOptionData[]>({
  key: "USE_OPTIONS",
  default: [],
});

export const useOptions = (articleId?: string) => {
  const { apiFetcher, businessId } = useXoraiaValue();
  const requestKey = `useOptions${articleId ? "-" + articleId : ""}`;

  const { data } = useSWR(
    requestKey,
    async () => {
      try {
        if (!apiFetcher || !apiFetcher.options) {
          throw "no-api-fetcher";
        }

        const _opts = await apiFetcher.options({ businessId, articleId });

        return _opts ?? [];
      } catch (error) {
        console.error("useOptions/Error =>", error);

        return [];
      }
    },
    { fallbackData: [] }
  );

  console.log("useOptions/Data =>", data);

  return { options: data };
};
